/* eslint-disable @nx/enforce-module-boundaries */
import { ChevronLeftIcon } from '@chakra-ui/icons';
import {
  CloseButton,
  HStack,
  IconButton,
  Image,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useMemo, useState } from 'react';
import { PostFormContext } from '../context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

// Map base keys -> messages


export const PostFormFeelingsPicker = forwardRef((props, ref) => {
  const {
    setOpenMoreOptions,
    setMoreOptionsActiveTab,
    feeling,
    setFeeling,
    feelingsAndActivities,
    moreOptionsDisc,
  } = useContext(PostFormContext);

  const {t} = useTranslator();

  const getTabMessage = (tabKey) => {
    switch (tabKey) {
      case 'Feeling':
        return t('createPost.feelings') || 'How are you feeling?';
      case 'Attending':
      case 'Celebrating':
      case 'More':
      default:
        return t('createPost.whatAreYouDoing') || 'What are you doing?';
    }
  };
  // Build tabs with both baseKey + localized category
  const tabs = useMemo(() => {
    if (!feelingsAndActivities) return [];

    return Object.entries(feelingsAndActivities).map(([baseKey, items]) => ({
      baseKey,                        // e.g. "Feelings"
      category: items[0]?.category,   // localized label, e.g. "感觉"
    }));
  }, [feelingsAndActivities]);

  const [activeTab, setActiveTab] = useState(tabs[0]?.baseKey);

  const onSelect = (val) => {
    if (feeling && feeling.name === val.name) {
      setFeeling(null);
    } else {
      setFeeling(val);
    }
    moreOptionsDisc?.onClose?.();
  }
  return (
    <>
      <HStack mb={4}>
        <IconButton
          onClick={() => setMoreOptionsActiveTab(null)}
          variant="ghost"
        >
          <ChevronLeftIcon />
        </IconButton>
        <HStack flex={1}>
          <Text fontWeight="bold" color="brandPrimary.500">
            {getTabMessage(activeTab) ?? 'What are you doing?'}
          </Text>
        </HStack>
        <CloseButton
          onClick={() => {
            setOpenMoreOptions(false);
            setMoreOptionsActiveTab(null);
          }}
        />
      </HStack>

      <Tabs index={tabs.findIndex((t) => t.baseKey === activeTab)}>
        <TabList>
          {tabs.map((t) => (
            <Tab onClick={() => setActiveTab(t.baseKey)} key={t.baseKey}>
              {t.category} {/* localized name */}
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          {tabs.map((t) => {
            const items = feelingsAndActivities[t.baseKey] || [];
            return (
              <TabPanel px={0} key={t.baseKey}>
                {items.length ? (
                  <HStack
                    flexDir={t.baseKey === 'Feeling' ? 'row' : 'column'}
                    spacing={0}
                    alignItems="flex-start"
                    flexWrap="wrap"
                  >
                    {items.map((f) => (
                      <HStack
                        cursor="pointer"
                        _hover={{ bg: 'gray.100' }}
                        p={2}
                        borderRadius="5"
                        key={f.id}
                        w={t.baseKey === 'Feeling' ? '33.33%' : 'full'}
                        onClick={() => onSelect(f)}
                        bg={feeling?.name === f.name ? 'gray.200' : 'transparent'}
                      >
                        <Stack flexShrink={0}>
                          <Image src={f.file} w="6" h="6" />
                        </Stack>
                        <Text wordBreak="none">{f?.name}</Text>
                      </HStack>
                    ))}
                  </HStack>
                ) : null}
              </TabPanel>
            );
          })}
        </TabPanels>
      </Tabs>
    </>
  );
});
